export default {
  text: 'Zdobyłeś {{points}} punktów ({{amount}}) za to zamówienie',
  button: 'Zaloguj się i odbierz punkty',
};
